var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { SVG } from '../global';
export var ArrowUp = function (props) {
    return (React.createElement(SVG, __assign({ testId: "arrow-up" }, props),
        React.createElement("path", { d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" }),
        React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })));
};
export var ArrowDown = function (props) {
    return (React.createElement(SVG, __assign({ testId: "arrow-down" }, props),
        React.createElement("path", { d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" }),
        React.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" })));
};
export var ArrowLeft = function (props) {
    return (React.createElement(SVG, __assign({ testId: "arrow-left" }, props),
        React.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
        React.createElement("path", { d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" })));
};
export var ArrowRight = function (props) {
    return (React.createElement(SVG, __assign({ testId: "arrow-right" }, props),
        React.createElement("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
        React.createElement("path", { d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" })));
};
export var UnfoldMore = function (props) {
    return (React.createElement(SVG, __assign({ testId: "unfold-more" }, props),
        React.createElement("path", { d: "M0 0h24v24H0z", fill: "none" }),
        React.createElement("path", { d: "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z" })));
};
//# sourceMappingURL=arrows.js.map